export default {
	mounted() {
		const logoContainer = document.querySelector('.szechenyi');

		setTimeout(() => {
			if (!logoContainer.classList.contains('hidden')) {
				this.toggleLogo();
			}
		}, 5000);
	},
	methods: {
		toggleLogo() {
			const logoContainer = document.querySelector('.szechenyi');
			logoContainer.classList.toggle('hidden');
		}
	}
}



// WEBPACK FOOTER //
// ../source/common/szechenyi/szechenyi.js